





















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ImageUpload from "./ImageUpload.vue";

// Types
import { IGalleryImageType } from "@/models/images";
import { IImage } from "@/store/types";

@Component({
  components: {
    "image-upload": ImageUpload
  }
})
export default class ImageGallerySwitcher extends Vue {
  @Prop({ required: true })
  public images!: IGalleryImageType[];

  @Prop({ default: 8 })
  public limit!: number;

  @Prop({ required: true })
  public reorder!: Function;

  @Prop({ required: true })
  public refresh!: Function;

  @Prop({ required: true })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  public sortElems: any[] = [];
  public savedOrder: any[] = [];
  public isReordering = false;

  public version = 0;

  public sortableOptions: {
    chosenClass: string;
    handle: string;
    animation: number;
  } = {
    chosenClass: "is-selected",
    handle: ".drag-and-drop",
    animation: 250
  };

  public showPreview(image = {} as IGalleryImageType) {
    this.$emit("showPreview", image);
  }

  public newImages(images, imageId) {
    const slicedImages = this.$_.slice(
      images,
      0,
      this.limit -
        this.images.length +
        (this.$_.find(this.images, ["id", imageId]) ? 1 : 0)
    );

    this.$_.forEach(slicedImages, image => {
      this.$set(
        this.sortElems,
        this.$_.findIndex(this.sortElems, ["exists", false]),
        {
          imageObj: image,
          exists: true,
          isUploading: true
        }
      );
    });

    this.$emit("newImages", slicedImages, imageId);
  }

  public deleteImage(imageId: IImage["id"]) {
    this.$emit("deleteImage", imageId);
  }

  public setDefault(imageId: IImage["id"]) {
    this.$emit("setDefault", imageId);
  }

  public async onDragDrop() {
    this.isReordering = true;
    this.savedOrder = this.$_.cloneDeep(this.sortElems);

    try {
      await this.reorder(
        this.$_.map(
          this.$_.filter(this.sortElems, image => !!image.hash),
          element => {
            return element.id;
          }
        )
      );
      await this.refresh();

      this.$buefy.toast.open({
        message: this.$t("_.object_successfully_updated", {
          object: this.$t("_.product_images_order")
        }) as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.sortElems = this.$_.cloneDeep(this.savedOrder);
    }

    this.isReordering = false;
  }

  public get galleryImages() {
    return this.$_.map(
      this.$_.concat(
        this.$_.map(this.images, image => {
          return {
            ...this.$_.pick(image, ["default", "id", "hash", "order"]),
            isUploading: false,
            exists: true
          };
        }),
        this.$_.map(
          Array(this.limit - this.images.length),
          () =>
            ({
              hash: "",
              isUploading: false,
              exists: false
            } as any)
        )
      ),
      (galleryImage, index) => {
        if (!galleryImage.id) {
          galleryImage.id = index;
        }
        return galleryImage;
      }
    );
  }

  // Watch
  @Watch("images", { immediate: true })
  public updateSortableData() {
    this.sortElems = this.$_.cloneDeep(this.galleryImages);
    this.savedOrder = this.$_.cloneDeep(this.sortElems);
    this.version++;

    if (this.images.length === 1) {
      this.showPreview(this.$_.get(this.images[0], "[0]", {}));
    }

    if (!this.images.length) {
      this.showPreview();
    }
  }
}
